import { c as _c } from "react/compiler-runtime";
import { DEFAULT_HOME_PATH, HOME_PATH, IS_MODAL } from '@/constants/config';
import { forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import BackToListButton from './BackToListButton';
const NO_BACK_BUTTON = DEFAULT_HOME_PATH !== HOME_PATH;
const SHOW_EMPTY_HEADER = IS_MODAL;
const AppHeader = (t0, ref) => {
    const $ = _c(6);
    const { children, className: t1, backButtonClassName } = t0;
    const incomingClassName = t1 === undefined ? "" : t1;
    const location = useLocation();
    const hasBackButton = !NO_BACK_BUTTON && location.pathname.split("?")[0] !== DEFAULT_HOME_PATH.split("?")[0];
    const className = `w-full flex flex-row ${SHOW_EMPTY_HEADER ? "min-h-6" : ""} ${incomingClassName}`;
    let t2;
    if ($[0] !== backButtonClassName || $[1] !== children || $[2] !== className || $[3] !== hasBackButton || $[4] !== ref) {
        t2 = hasBackButton || children || SHOW_EMPTY_HEADER ?
            <div ref={ref} className={className}>
      {hasBackButton ? <BackToListButton className={backButtonClassName}/> : null} {children}
    </div> : null;
        $[0] = backButtonClassName;
        $[1] = children;
        $[2] = className;
        $[3] = hasBackButton;
        $[4] = ref;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    return t2;
};
export default forwardRef(AppHeader);
